<template>
  <div class="nv-grid-col filters-col" v-if="product">
    <div class="nv-w-100">
      <h6 class="nv-d-block">
        {{ $t('all_topics') }}
      </h6>
      <nv-list>
        <nv-list-item v-for="(topic, idx) of product?.supportSections" :key="idx">
          <nuxt-link slot="start" :to="localePath(`/support/products/${product.slug}/${topic.slug}`)">
            <div class="nv-d-flex nv-flex-column">
              <div class="nv-d-flex nv-align-items-center">
                <nv-radio :checked="$route.params.section === sectionSlug" />
                <!-- <img :src="topic.icon" :alt="topic.name" class="nv-mr-1"> -->
                <span class="nv-mb-0">
                  {{ topic.name }}
                </span>
              </div>
            </div>
          </nuxt-link>
        </nv-list-item>
      </nv-list>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useProductStore } from '~/store/product';

// ---------------------------------------
// Props
// ---------------------------------------
defineProps({
  sectionSlug: {
    type: String,
    required: true
  }
});

// ---------------------------------------
// Hooks
// ---------------------------------------
const localePath = useLocalePath();

// ---------------------------------------
// State
// ---------------------------------------
const productStore = useProductStore();
const { product } = storeToRefs(productStore);
</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.filters-col {
  max-width: 320px;
}
</style>
